"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.setActivePartners = exports.setPipelineVersion = exports.setViaName = exports.setBusinessId = void 0;
var types = __importStar(require("./actionTypes"));
function setBusinessId(businessId) {
    return function (dispatch) {
        dispatch({
            type: types.SET_BUSINESS_ID,
            data: {
                businessId: businessId,
            },
        });
    };
}
exports.setBusinessId = setBusinessId;
function setViaName(viaName) {
    return function (dispatch) {
        dispatch({
            type: types.SET_VIA_NAME,
            data: {
                viaName: viaName,
            },
        });
    };
}
exports.setViaName = setViaName;
function setPipelineVersion(pipelineVersion) {
    return function (dispatch) {
        dispatch({
            type: types.SET_PIPELINE_VERSION,
            data: {
                pipelineVersion: pipelineVersion,
            },
        });
    };
}
exports.setPipelineVersion = setPipelineVersion;
function setActivePartners(activePartners) {
    return function (dispatch) {
        dispatch({
            type: types.SET_ACTIVE_PARTNERS,
            data: {
                activePartners: activePartners,
            },
        });
    };
}
exports.setActivePartners = setActivePartners;
